var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_3061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 105,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1875 56.3125H43.8125C42.0937 56.3125 40.6875 54.9063 40.6875 53.1875V43.8125C40.6875 42.0937 42.0937 40.6875 43.8125 40.6875H53.1875C54.9063 40.6875 56.3125 42.0937 56.3125 43.8125V53.1875C56.3125 54.9063 54.9063 56.3125 53.1875 56.3125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1875 81.3125H43.8125C42.0937 81.3125 40.6875 79.9063 40.6875 78.1875V68.8125C40.6875 67.0937 42.0937 65.6875 43.8125 65.6875H53.1875C54.9063 65.6875 56.3125 67.0937 56.3125 68.8125V78.1875C56.3125 79.9063 54.9063 81.3125 53.1875 81.3125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5625 43.8125H81.3125",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5625 50.0625H73.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5625 68.8125H81.3125",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5625 75.0625H73.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 46.9375L48.5 50.0625L53.1875 45.375",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 103.5,
    height: 103.5,
    rx: 51.75,
    stroke: "#0078BB",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 60.5C113 89.4949 89.4949 113 60.5 113C31.5051 113 8 89.4949 8 60.5C8 31.5051 31.5051 8 60.5 8C89.4949 8 113 31.5051 113 60.5Z",
    fill: "url(#paint0_linear_2938_3061)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2938_3061",
    x1: 61,
    y1: -12,
    x2: 60.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatProcess);
export default __webpack_public_path__ + "static/media/feat_process.5fe09f3949f62146a0de738aca89def7.svg";
export { ForwardRef as ReactComponent };